import { globalErrorHandler } from "./ErrorHandler";
import { store } from "../";
import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { PublicClientApplication, SilentRequest } from "@azure/msal-browser";
import { getAccessToken, getAccount } from "../utils/AuthHelper";

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  errors?: string[];
}
export const customFetch = async (url: string | Request, init?: RequestInit, useToken=true): Promise<Response> => {
  const sessionState = store.getState().sessionState;
  const fetchUrl = `${getApiUrl()}${url}`;
  const silentRequest: SilentRequest = {
    scopes: sessionState.appRegistration?.scopes ?? [],
    account: getAccount(sessionState.authClient as PublicClientApplication),
  };

  if (sessionState.authClient && useToken) {
    // TODO: may check for 'InteractionStatus' if interaction in progress error occurs: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/errors.md#browserautherrors
    let accessToken = await getAccessToken("CustomFetch.tsx-customFetch", sessionState.authClient as PublicClientApplication, silentRequest);
    init = init || {};
    init.headers = init.headers || {};
    init.headers = { ...init.headers, Authorization: "Bearer " + accessToken };
  }
  
  return window
    .fetch(fetchUrl, init)
    .then(globalErrorHandler);
}

export const getBaseQuery = () => {
  return fetchBaseQuery({
    baseUrl: getApiUrl(),
    prepareHeaders,
  });
};

const prepareHeaders = async (headers: Headers, api: { getState: () => unknown }): Promise<Headers> => {
  const token = await getToken();
  headers.set("authorization", `Bearer ${token}`);
  return headers;
};

const getToken = async () => {
  const sessionState = store.getState().sessionState;

  if (sessionState.authClient) {
    const silentRequest: SilentRequest = {
      scopes: sessionState.appRegistration?.scopes ?? [],
      account: getAccount(sessionState.authClient as PublicClientApplication),
    };
    
    return await getAccessToken("CustomFetch.tsx-getToken", sessionState.authClient as PublicClientApplication, silentRequest);
  }
  return "";
}

const getApiUrl = () => {
  return getBaseUrl() + "/api/";
};

const getCurrentHost = (): string => {
  const host = window.location.host;
  const url = window.location.protocol + "//" + host;
  return url;
};

const getBaseUrl = (): string => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    return "https://localhost:51412";
  }

  return getCurrentHost();
};
